/* eslint-disable @typescript-eslint/no-unused-vars */
import { ComponentRefPair } from "..//models/pageConfig"
import ComponentService from "../services/component"
import { ProviderService } from "../services/provider"
import { ServiceRefMapPair } from "../services/Service"

const AppGlobal = <T>(config: {
    providers: Array<ServiceRefMapPair>
    components: Array<ComponentRefPair>
}) => {
    return (ctr: any): void => {
        // insert toute les references vers les services disponibles
        if (config.providers?.length)
            config.providers.forEach((serviceRepPair: ServiceRefMapPair) =>
                ProviderService.getInstance().set({
                    key: serviceRepPair.key,
                    service: serviceRepPair.serviceRef,
                })
            )
        // insert toute les references vers les conposants disponibles
        if (config.components?.length)
            config.components.forEach((componentRefPair: ComponentRefPair) =>
                ComponentService.getInstance().addRef(componentRefPair)
            )
    }
}

export default AppGlobal
